import React from "react"
import styled from "styled-components"
import { Img } from "wordsby-components"
// import { Link } from "gatsby"
import Typography from "@material-ui/core/Typography"

import * as theme from "../../../theme"

const Downloads = ({ image, link, description }) => {
  return (
    <Container>
      <Image href={link.url} target="_blank">
        <Img field={image.url} />
      </Image>
      <Description>
        <Typography variant="body1" gutterBottom>
          {description}
        </Typography>
        <Feature href={link.url} target="_blank">
          <Typography variant="h6">{link.title}</Typography>
        </Feature>
      </Description>
    </Container>
  )
}

export default Downloads

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 20px 0;
  @media (min-width: 1060px) {
    margin: 45px 0;
    flex-direction: row;
  }
`
const Image = styled.a`
  margin: 20px 0;
  @media (min-width: 1060px) {
    margin-right: 60px;
    margin-top: 0;
    margin-bottom: 0;
  }
`
const Description = styled.div`
  width: 100%;
`

const Feature = styled.a`
  text-decoration: none;
  display: inline-block;
  &:hover {
    &:after {
      transform: scaleX(1);
    }
  }
  &:after {
    transform-origin: 0 100%;
    display: block;
    content: "";
    border-bottom: solid 2px ${theme.color.green};
    transform: scaleX(0);
    transition: transform 150ms ease-in-out;
  }
`
